export const DATE_ISO_FORMAT = "YYYY-MM-DD";
export const DATE_SLASH_FORMAT = "YYYY/MM/DD";
export const DATE_SLASH_SHORT_FORMAT = "YY/MM/DD";
